import { useState } from "react";
import { useNavigate } from "react-router-dom";

import DashboardLayout from "../../layouts/DashboardLayout";
import { addPlan } from "../../services/membershipService";
import { FaGem } from "react-icons/fa";

import "./AddMembership.css";

export default function AddMembership() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    planName: "",
    duration: "",
    price: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (!formData.planName || !formData.duration || !formData.price) {
      alert("Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      await addPlan({
        planName: formData.planName,
        duration: Number(formData.duration),
        price: Number(formData.price),
      });

      alert("Membership Plan Added Successfully");

      navigate("/memberships");
    } catch (error) {
      console.error(error);
      alert("Error Adding Plan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="membership-form-page">
        <div className="membership-form-header">
          <h1>Create Membership Plan</h1>

          <p style={{ fontWeight: "bold", color: "white" }}>
            Configure pricing, duration and membership packages for your gym.
          </p>
        </div>

        <div className="membership-form-card">
          <div className="membership-icon">
            <FaGem />
          </div>

          <h2>New Membership Plan</h2>

          <p className="membership-subtitle">
            Create custom plans for your gym members.
          </p>

          <div className="form-group">
            <label>Plan Name</label>

            <input
              type="text"
              name="planName"
              placeholder="Gold Plan"
              value={formData.planName}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Duration (Days)</label>

            <input
              type="number"
              name="duration"
              placeholder="30"
              value={formData.duration}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Price (₹)</label>

            <input
              type="number"
              name="price"
              placeholder="1500"
              value={formData.price}
              onChange={handleChange}
            />
          </div>

          <button
            className="membership-save-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Membership Plan"}
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
